/* Copyright 2021, Milkdown by Mirone. */
import { findChildren } from '@milkdown/utils';
import { Plugin, PluginKey } from 'prosemirror-state';
import { getDecorations } from './get-decorations';
export const key = 'MILKDOWN_PLUGIN_PRISM';
export function Prism(name) {
    return new Plugin({
        key: new PluginKey(key),
        state: {
            init: (_, { doc }) => {
                return getDecorations(doc, name);
            },
            apply: (transaction, decorationSet, oldState, state) => {
                var _a, _b;
                const isNodeName = state.selection.$head.parent.type.name === name;
                const isPreviousNodeName = oldState.selection.$head.parent.type.name === name;
                const oldNode = findChildren((node) => node.type.name === name)(oldState.doc);
                const newNode = findChildren((node) => node.type.name === name)(state.doc);
                const codeBlockChanged = transaction.docChanged &&
                    (isNodeName ||
                        isPreviousNodeName ||
                        oldNode.length !== newNode.length ||
                        ((_a = oldNode[0]) === null || _a === void 0 ? void 0 : _a.node.attrs.language) !== ((_b = newNode[0]) === null || _b === void 0 ? void 0 : _b.node.attrs.language));
                if (codeBlockChanged) {
                    return getDecorations(transaction.doc, name);
                }
                return decorationSet.map(transaction.mapping, transaction.doc);
            },
        },
        props: {
            decorations(state) {
                return this.getState(state);
            },
        },
    });
}
//# sourceMappingURL=prism.js.map